export const htmlTemplate = `<main class="p-4">
    <div class="flex place-items-center border-l-4 border-red-300 bg-red-50 p-4 text-red-800 dark:border-red-800 dark:bg-gray-800 dark:text-red-400" role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="h-6 w-6 shrink-0">
            <path fill-rule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" />
        </svg>

        <h1 class="hidden">Interne fout opgetreden</h1>

        <div class="ml-3 font-medium">
            <strong>Er is iets fout gegaan tijdens het opvragen van deze pagina. Je kunt deze melding veilig wegklikken.</strong>
        </div>
    </div>
</main>`;

export const htmlTemplateWizard = `<main class="p-4">
    <div class="flex p-4 place-items-center text-red-800 border-l-4 border-red-300 bg-red-50 dark:text-red-400 dark:bg-gray-800 dark:border-red-800" role="alert">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6 shrink-0">
            <path fill-rule="evenodd" d="M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z" clip-rule="evenodd" />
        </svg>

        <h1 class="hidden">Interne fout opgetreden</h1>

        <div class="ml-3 font-medium">
            Er is een fout opgetreden tijdens het verwerken van je aanvraag. Neem contact op met AutoWise als deze foutmelding aanhoudt.
        </div>
    </div>
</main>`;
